/* eslint-disable react-hooks/exhaustive-deps */
import { Spin, Timeline } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconEmpty from '../../../dpia/components/iconEmpty';
import useQuery from '../../../../util/useQuery';

export default function History({ service, callHistory, setCallHistory }) {
    const [histories, setHistories] = useState([]);
    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [total, setTotal] = useState(0);
    const { t } = useTranslation();

    const params = useQuery();
    const groupId = params.get('id');

    const getHistory = async (params) => {
        setLoading(true);
        try {
            setTimeout(async () => {
                const { data } = await service(params);
                if (data?.resultData) {
                    if (params.p === 1) {
                        setHistories(data.resultData?.result);
                        setPage(2);
                    } else {
                        const history = histories.concat(
                            data.resultData?.result
                        );
                        setHistories(history);
                        setPage(page + 1);
                    }
                    setTotal(data?.resultData?.total);
                    setLoading(false);
                } else {
                    setLoading(false);
                }
            }, 300);
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    useEffect(() => {
        if (callHistory) {
            const params = {
                groupId,
                p: 1,
                ps: 10,
            };
            setHistories([]);
            getHistory(params);
            setCallHistory(false);
        }
    }, [callHistory]);

    const scrollEvent = (e) => {
        const scrollTop = e.target.scrollTop;
        const scrollHeight = e.target.scrollHeight - e.target.clientHeight;
        const threshold = scrollHeight * 0.9; // 90% of the total height
        if (scrollTop >= threshold && total > histories.length && !loading) {
            const params = {
                groupId,
                p: page,
                ps: 10,
            };
            getHistory(params);
        }
    };

    return (
        <Timeline>
            <Spin spinning={loading}>
                <div
                    onScroll={scrollEvent}
                    className="h-[95vh] overflow-y-scroll p-4 pb-12"
                >
                    {histories.length > 0 ? (
                        histories.map((item, i) => (
                            <Timeline.Item
                                key={item?.dataBreachFormId}
                                color={i === 0 ? '#F0536F' : '#3699FF'}
                            >
                                <div
                                    className={classNames(
                                        'bg-[#EDEEF9] p-2 rounded-lg space-y-2 text-left w-full',
                                        { 'bg-[#F4F6FC]': i !== 0 }
                                    )}
                                >
                                    <div className="grid grid-cols-5 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('dataFlow.LogDate')} :
                                        </div>
                                        <div className="col-span-3">
                                            {item.logDate || '-'}
                                        </div>
                                    </div>{' '}
                                    <div className="grid grid-cols-5 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('dataFlow.updateBy')} :
                                        </div>
                                        <div className="col-span-3">
                                            {item.updateBy || '-'}
                                        </div>
                                    </div>{' '}
                                    <div className="grid grid-cols-5 text-xs">
                                        <div className="col-span-2 font-semibold">
                                            {t('dataFlow.Version')} :
                                        </div>
                                        <div className="col-span-3">
                                            {item.version || '-'}
                                        </div>
                                    </div>
                                </div>
                            </Timeline.Item>
                        ))
                    ) : (
                        <div className="h-[30vh] grid items-center justify-center">
                            <div className="-mt-16">
                                <IconEmpty />
                            </div>
                        </div>
                    )}
                </div>
            </Spin>
        </Timeline>
    );
}
